import { Component, EventEmitter, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GisDimsMapComponent } from 'src/app/main/shared/gis-dims-map/gis-dims-map.component';
import { InfomodalComponent } from 'src/app/main/shared/infomodal/infomodal.component';
import { DataService } from 'src/app/main/shared/services/data.service';
import { UtilsService } from 'src/app/utils/utils.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-land-surface-temp-sidebar',
  templateUrl: './land-surface-temp-sidebar.component.html',
  styleUrls: ['./land-surface-temp-sidebar.component.scss']
})
export class LandSurfaceTempSidebarComponent implements OnInit, OnChanges {
  @Input() labelStrings: any;
  @Input() blockNum: number;
  @Output() playPos = new EventEmitter<any>();

  isInitialLoad: boolean = false;
  selected: string;
  dateIndexLength: number = 7;
  activeRadioList: boolean[] = [];
  sourceOptions: any = ['IMD', 'ECMWF'];
  selectedSource: any = 'IMD';
  queryParams: any;
  isDistrictChecked: boolean = false
  destroy: any = new Subject();
  subscriptions: any = [];
  sessionStorage: any = {
    params: {}
  };

  constructor(
    public gisUtils: UtilsService,
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private dataService: DataService,
    private gisMapComp: GisDimsMapComponent
  ) {
    this.selected = this.router.url.split('/')[2];
  }

  ngOnInit() {
    this.isInitialLoad = true;
    this.subscribeEvents()
    this.setParams()
  }

  subscribeEvents() {
    const selectedParamsRef = this.gisUtils.selectedParams.pipe(takeUntil(this.destroy)).subscribe((params: any) => {
      let sessionStorageSelectedParams: any = sessionStorage.getItem('params');
      if (Object.keys(params).length > 0) {
        this.queryParams = params;
      } else {
        this.queryParams = sessionStorageSelectedParams ? JSON.parse(sessionStorageSelectedParams) : {};
        this.sessionStorage.params = { ...this.queryParams };
        if (Object.keys(this.queryParams).length) {
          this.gisUtils.setSelectedParams(this.queryParams);
        }
      }
    });
    this.subscriptions.push(selectedParamsRef)
  }

  setParams() {
    if (this.isInitialLoad && !Object.keys(this.sessionStorage.params).length) {
      this.requestSelectedFilterParams();
    }
    this.isInitialLoad = false;
  }

  ngOnChanges(change: SimpleChanges) {
    if (!isNullOrUndefined(this.labelStrings) && this.labelStrings.length > 0) {
      let timeStamp = this.labelStrings[this.blockNum] ? this.labelStrings[this.blockNum].groupName : null;
      if (timeStamp) {
        this.gisUtils.setTimeStamp(timeStamp);
      }
      if (!isNullOrUndefined(change.blockNum) && Object.keys(this.labelStrings).length > 0) {
        if (change.blockNum.currentValue) {
          this.buttonClicked(change.blockNum.currentValue);
        }
      } else {
        this.buttonClicked(this.blockNum);
      }
      const len = this.activeRadioList.length;
      this.activeRadioList = [];
      for (let i = 0; i < this.dateIndexLength; ++i) {
        if (i === this.blockNum) {
          this.activeRadioList.push(true);
        } else {
          this.activeRadioList.push(false);
        }
      }
    }
  }

  requestSelectedFilterParams() {
    let currentUrlParams: any = {};
    if (!this.isInitialLoad) {
      currentUrlParams = this.queryParams;
    }
    currentUrlParams['component'] = 'LAND_SURFACE_TEMP';
    currentUrlParams['source'] = 'IMD_LONG_RANGE'
    if (this.isInitialLoad) {
      currentUrlParams['actionType'] = 'filter';
      currentUrlParams['view'] = 'Admin';
      currentUrlParams['pType'] = 'COUNTRY';
      currentUrlParams['cType'] = 'STATE';
      currentUrlParams['parentLoc'] = 'COUNTRY';
      currentUrlParams['dashboardView'] = 'INDIA';
      currentUrlParams['dashboardType'] = 'gis';
      const userLocationConfig = this.dataService.formQuerParamsVariables(this.gisMapComp.metaInfo.userDetailsJson.data.location, this.gisMapComp.metaInfo.userDetailsJson.data.locType);
      const currentLocations: any = userLocationConfig.locationInfo[userLocationConfig.types.pType.toLowerCase()].split('##');
      currentUrlParams['pUUID'] = currentLocations[1]
      currentUrlParams['locName'] = currentLocations[0]
      currentUrlParams['locType'] = userLocationConfig.types.pType;
      currentUrlParams['pEUUID'] = userLocationConfig.locationInfo.country.split('##')[1];
      currentUrlParams['location'] = userLocationConfig.locationInfo.location;
      currentUrlParams['source'] = 'IMD_LONG_RANGE'
      this.isInitialLoad = false
    }
    this.gisUtils.setSelectedParams(currentUrlParams);
  }

  validate(i) {
    if (this.labelStrings[i] == undefined || this.labelStrings[i] == null) {
      return '';
    } else {
      return this.labelStrings[i]['fullLabel'];
    }
  }

  buttonClicked(blockNumber, from?: string) {
    if (from === 'HTML') {
      this.playPos.emit(blockNumber);
    }
    if (this.activeRadioList && this.activeRadioList[blockNumber]) {
      this.gisUtils.setIndex(this.labelStrings[blockNumber]['groupName']);
    }
  }

  infoclick(value) {
    const modalRef = this.modalService.open(InfomodalComponent, {
      backdrop: 'static',
      keyboard: true,
      windowClass: 'backgroundTransparent  infocomponent'
    });
    modalRef.componentInstance.selected = value;
  }

  sendPlayPos(event) {
    this.playPos.emit(event);
  }

  toggleDistrictLayer(event) {
    const checkbox = event.target as HTMLInputElement;
    this.isDistrictChecked = checkbox.checked;
    this.gisUtils.lstDistrictLayerToggle.next(this.isDistrictChecked)
  }
}
